import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["controls", "radiusSelect", "item", "section", "visibleCount", "noResults"]

  connect() {
    if (!this.hasRadiusSelectTarget || !navigator.geolocation) return

    this.radiusSelectTarget.value = "50"
    navigator.geolocation.getCurrentPosition(
      (position) => this.enable(position),
      () => this.disable(),
      { enableHighAccuracy: false, maximumAge: 300000, timeout: 10000 }
    )
  }

  enable(position) {
    this.userLatitude = position.coords.latitude
    this.userLongitude = position.coords.longitude

    if (this.hasControlsTarget) this.controlsTarget.classList.remove("hidden")
    this.filter()
  }

  disable() {
    if (this.hasControlsTarget) this.controlsTarget.classList.add("hidden")
  }

  filter() {
    if (this.userLatitude == null || this.userLongitude == null) return

    const radiusKm = Number.parseFloat(this.radiusSelectTarget.value || "50")
    let visibleCount = 0

    this.itemTargets.forEach((item) => {
      const latitude = Number.parseFloat(item.dataset.sessionsLocationFilterLatitude || "")
      const longitude = Number.parseFloat(item.dataset.sessionsLocationFilterLongitude || "")
      const visible = Number.isFinite(latitude) &&
        Number.isFinite(longitude) &&
        this.distanceKm(this.userLatitude, this.userLongitude, latitude, longitude) <= radiusKm

      item.classList.toggle("hidden", !visible)
      if (visible) visibleCount += 1
    })

    this.sectionTargets.forEach((section) => {
      const hasVisibleItem = Array.from(section.querySelectorAll("[data-sessions-location-filter-target~='item']"))
        .some((item) => !item.classList.contains("hidden"))

      section.classList.toggle("hidden", !hasVisibleItem)
    })

    if (this.hasNoResultsTarget) {
      this.noResultsTarget.classList.toggle("hidden", visibleCount > 0)
    }

    if (this.hasVisibleCountTarget) {
      const label = this.visibleCountTarget.dataset.sessionsLocationFilterLabelValue || ""
      const noun = [label, visibleCount === 1 ? "session" : "sessions"].filter(Boolean).join(" ")
      this.visibleCountTarget.textContent = `${visibleCount} ${noun} shown.`
    }
  }

  distanceKm(firstLatitude, firstLongitude, secondLatitude, secondLongitude) {
    const earthRadiusKm = 6371
    const deltaLatitude = this.toRadians(secondLatitude - firstLatitude)
    const deltaLongitude = this.toRadians(secondLongitude - firstLongitude)
    const firstLatitudeRadians = this.toRadians(firstLatitude)
    const secondLatitudeRadians = this.toRadians(secondLatitude)

    const a = Math.sin(deltaLatitude / 2) ** 2 +
      Math.cos(firstLatitudeRadians) * Math.cos(secondLatitudeRadians) *
      Math.sin(deltaLongitude / 2) ** 2

    return earthRadiusKm * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  }

  toRadians(degrees) {
    return degrees * Math.PI / 180
  }
}
